import { CONFIG } from "../config.js";

/**
 * Formats a number as currency
 * @param {number} amount - The amount to format
 * @param {string} currency - Currency symbol
 * @returns {string} Formatted currency string
 */
export function formatCurrency(amount, currency = CONFIG.DEFAULT_CURRENCY) {
  const formatted = new Intl.NumberFormat("lo-LA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));

  return `${currency}${formatted}`;
}

/**
 * Formats a date in Lao locale
 * @param {Date|string} date - Date to format
 * @returns {string} Formatted date string
 */
export function formatDate(date) {
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleDateString("lo-LA", CONFIG.DATE_FORMAT.OPTIONS);
}

/**
 * Formats a date as short format (DD/MM/YYYY)
 * Handles YYYY-MM-DD strings without timezone shift.
 * @param {Date|string} date - Date to format
 * @returns {string} Formatted date string
 */
export function formatDateShort(date) {
  // If it's a YYYY-MM-DD string, parse parts directly to avoid UTC→local shift
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }
  const d = typeof date === "string" ? new Date(date) : date;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Gets Lao month name
 * @param {number} monthIndex - Month index (0-11)
 * @returns {string} Lao month name
 */
export function getLaoMonth(monthIndex) {
  return CONFIG.LAO_MONTHS[monthIndex] || "";
}

/**
 * Formats a number with thousand separators
 * @param {number} num - Number to format
 * @returns {string} Formatted number
 */
export function formatNumber(num) {
  return new Intl.NumberFormat("lo-LA").format(num);
}

/**
 * Converts Buddhist year to Gregorian year
 * @param {number} buddhistYear - Buddhist year
 * @returns {number} Gregorian year
 */
export function buddhistToGregorian(buddhistYear) {
  return buddhistYear - 543;
}

/**
 * Converts Gregorian year to Buddhist year
 * @param {number} gregorianYear - Gregorian year
 * @returns {number} Buddhist year
 */
export function gregorianToBuddhist(gregorianYear) {
  return gregorianYear + 543;
}
